import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">Contact Us</h1>

        <div className="bg-white shadow-xl rounded-2xl overflow-hidden">
          <div className="p-8 grid gap-8 md:grid-cols-2">
            
            {/* Contact Info */}
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-bold text-gray-900">📍 Our Location</h3>
                <p className="text-gray-600 mt-1">
                  Goverdhan Enclave,<br />
                  Lucknow, Uttar Pradesh
                </p>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-900">📞 Phone & WhatsApp</h3>
                <p className="text-gray-600 mt-1">+91 8957199050</p>
                <p className="text-sm text-gray-500">(Available 8:30 AM - 10:30 PM)</p>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-900">📧 Email</h3>
                <p className="text-green-600 font-medium mt-1">ddstores.lko@gmail.com</p>
              </div>
            </div>

            {/* Direct Actions */}
            <div className="flex flex-col justify-center space-y-4">
              <a 
                href="https://wa.me/918957199050" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-4 rounded-xl transition-all shadow-md hover:shadow-lg"
              >
                <span>💬</span> Chat on WhatsApp
              </a>
              
              <a 
                href="tel:+918957199050" 
                className="flex items-center justify-center gap-2 w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-xl transition-all shadow-md hover:shadow-lg"
              >
                <span>📞</span> Call Us Now
              </a>
            </div>

          </div>
          
          {/* Map Placeholder (Optional) */}
          <div className="bg-gray-200 h-48 w-full flex items-center justify-center text-gray-500">
             (Google Map will go here later)
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;